// src/icons/Zap.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Zap() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33395 1.60194C9.33395 0.612524 8.05068 0.224007 7.50188 1.04724L2.12471 9.11298C1.68167 9.77751 2.15806 10.6677 2.95676 10.6677H6.66728V14.4001C6.66728 15.3895 7.95048 15.778 8.49928 14.9548L13.8765 6.88904C14.3195 6.2245 13.8431 5.33435 13.0444 5.33435H9.33395V1.60194Z",
          fill: "currentColor"
        }
      )
    }
  );
}

export {
  Zap
};
